import { urlParams } from './request';
import { isPossiblePhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import { isEmptyString, ifFieldEmptyReturnDefault, isNonEmptyString } from './text';

export const saveInstructorProfile = (callSaveProfileAPI, userId, profileData) =>
    callSaveProfileAPI('../instructor/saveInstructorInstitutionProfile.html', {
        method: 'POST',
        body: urlParams({
            instructorId: userId,
            profileId: profileData.profileId,
            pronouns: profileData.pronouns,
            schoolEmail: profileData.schoolEmail,
            // calendarManagers TODO: SD-12018
            // departments TODO
            // offices TODO 
            homePage: profileData.homePage,
            title: profileData.title,
            phone: profileData.phone,
            preferredEmail: profileData.preferredEmail,
            cellPhone: profileData.cellPhone,
            videoPhone: profileData.videoPhone,
            correspondenceTo: profileData.correspondenceTo,
            timeZone: profileData.timeZone,
            appointmentLinkAvailable: profileData.appointmentLinkAvailable,
            profileLinkAvailable: profileData.profileLinkAvailable,
            generalOverview: profileData.generalOverview,
            biography: profileData.biography
        })
    });

export const saveInstructorNotificationPreferences = (callSaveNotificationPreferencesAPI, userId, notificationPreferences) =>
    callSaveNotificationPreferencesAPI('../instructor/saveInstructorNotificationPreferences.html', {
        method: 'POST',
        body: urlParams({
            instructorId: userId,
            profileId: notificationPreferences.profileId,
            alertPreviousTime: ifFieldEmptyReturnDefault(notificationPreferences.alertPreviousTime, 15),
            alertType: notificationPreferences.alertType,
            appAlertFlag: notificationPreferences.appAlertFlag,
            dailyNotification: notificationPreferences.dailyNotification,
            dailyNotificationTime: notificationPreferences.dailyNotificationTime,
            exchangeFreeBusyEnabled: notificationPreferences.exchangeFreeBusyEnabled,
            flagAssigned: notificationPreferences.flagAssigned,
            flagCleared: notificationPreferences.flagCleared,
            flagRaised: notificationPreferences.flagRaised,
            googleCalUrl: notificationPreferences.googleCalUrl,
            googleFreeBusyEnabled: notificationPreferences.googleFreeBusyEnabled,
            mailNewApp: notificationPreferences.mailNewApp,
            mailNewBlock: notificationPreferences.mailNewBlock,
            planningReminderTime: notificationPreferences.planningReminderTime,
            planningReminderType: notificationPreferences.planningReminderType,
            planningReminderWhen: notificationPreferences.planningReminderWhen,
            textNotificationEnabled: notificationPreferences.textNotificationEnabled,
            weeklyNotification: notificationPreferences.weeklyNotification,
            weeklyNotificationDay: notificationPreferences.weeklyNotificationDay,
            weeklyNotificationTime: notificationPreferences.weeklyNotificationTime,
            weekendRemindersOff: notificationPreferences.weekendRemindersOff
        })
    });

export const saveAppointmentPreferences = (callAppointmentPreferencesSaveAPI, userId, appointmentPreferences) =>
    callAppointmentPreferencesSaveAPI('../instructor/saveInstructorAppointmentPreferences.html', {
        method: 'POST',
        body: urlParams({
            instructorId: userId,
            minAppTime: ifFieldEmptyReturnDefault(appointmentPreferences.minAppTime, 15),
            deadLineType: ifFieldEmptyReturnDefault(appointmentPreferences.deadLineType, "NONE"),
            "deadLineValue['DAY_BEFORE']": ifFieldEmptyReturnDefault(appointmentPreferences.deadLineValue.DAY_BEFORE, "5:00 PM"),
            "deadLineValue['ON_DAY']": ifFieldEmptyReturnDefault(appointmentPreferences.deadLineValue.ON_DAY, "9:00 AM"),
            "deadLineValue['HOURS_BEFORE']": ifFieldEmptyReturnDefault(appointmentPreferences.deadLineValue.HOURS_BEFORE, 1),
            schedulingType: ifFieldEmptyReturnDefault(appointmentPreferences.schedulingType, "ASSIGNED_TIMES")
        })
    });

export const isSupportedCountryCode = (countryCode, supportedCountries, cellPhone) => {
    if (isEmptyString(countryCode) || isEmptyString(supportedCountries) || isEmptyString(cellPhone))
        return false;
    return supportedCountries.split(',').some(supportedCode => supportedCode === countryCode);
};

export const isSupportedCellPhoneNumber = (cellPhone, supportedCountries) => {
    if (!isEmptyString(cellPhone) && isPossiblePhoneNumber(cellPhone))
        return isSupportedCountryCode(parsePhoneNumber(cellPhone).country, supportedCountries, cellPhone);
    return true;
};

/**
 * Checks the provided configuration for valid JSON containing one of the keys used to store
 * help desk information and a non-empty value, which is required to use texting options. In
 * the case of an empty or missing config, invalid JSON, or all 3 keys/values missing, the
 * result will be false.
 *
 * @param {string} config - the value of the tenant configuration containing the json
 * @returns {boolean} whether the tenant config contains the required keys
 */
export const configHasValidHelpDeskKeys = config => {
    if (!config) return false;
    try {
        const configJson = JSON.parse(config);
        return isNonEmptyString(configJson.phone) || isNonEmptyString(configJson.url) || isNonEmptyString(configJson.email);
    } catch (e) {
        return false;
    }
}
